import * as styles from './Column.module.css'

import React from 'react'
import classNames from 'classnames'

import CardImage from 'components/cards/CardImage'
import CardHover from 'components/cards/CardHover'

interface Props {
  cards: {
    name: string
    set?: string
    id?: string
    count?: number
    label?: string | null
  }[]
}

const Column: React.FC<Props> = (props) => {
  const { cards } = props

  return (
    <div>
      {cards.map((card, index) => (
        <div
          className={classNames(styles.card, {
            [styles.withLabel]: card.count != null || card.label != null,
          })}
          key={index}
        >
          <CardHover card={card.name} set={card.set} id={card.id}>
            <CardImage set={card.set} id={card.id}>
              {card.name}
            </CardImage>
          </CardHover>

          {card.label != null ? (
            <div className={styles.label}>{card.label}</div>
          ) : card.count != null ? (
            <div className={styles.count}>{card.count}x</div>
          ) : null}
        </div>
      ))}
    </div>
  )
}

export default Column
